import { ApplicationStatus } from 'api';

export const getUserFriendlyStatuses = () => {
    return Object.values(ApplicationStatus).map((status) =>
        status.split('_').join(' ').toLocaleLowerCase()
    );
};

export const getUserFriendlyStatus = (status: ApplicationStatus) => {
    return status.split('_').join(' ').toLocaleLowerCase();
};

export const convertBackToEnum = (userFriendlyStatus: string): ApplicationStatus => {
    const convertedToAppStatusValue = userFriendlyStatus.toUpperCase().split(' ').join('_');
    return ApplicationStatus[convertedToAppStatusValue as keyof typeof ApplicationStatus];
};
